import { securePostRequest, secureRequest, postRequest } from 'utils/request';


export const login = (body: any) => postRequest(`/api/v1/auth/login`)(body);

export const logout = () =>
  secureRequest(`api/v1/auth/logout`, [], {
    handleNoResponse: true,
    storeToken: false,
    type: 'json',
  });

export const updatePermissions = (body: any) => securePostRequest(`/api/v1/auth/update-permissions`)(body);

export const loginViaAD = (body: any) => postRequest('/s-ad/auth')(body);
